// This file is generated by the update-rd-teams script. Run "pnpm update:rd-teams" to update.
// It needs to be pushed to the repository. Otherwise, all builds could break if a team changes.
export var teamAliasMappings = {
    "backend-foundation": "backend-foundation",
    "platform-foundation": "backend-foundation",
    "service-foundation": "backend-foundation",
    foundation: "backend-foundation",
    cartel: "cartel",
    "cloud-infra": "cloud-infra",
    infrastructure: "cloud-infra",
    cloudinfra: "cloud-infra",
    infra: "cloud-infra",
    "cloud-intelligence": "cloud-intelligence",
    finops: "cloud-intelligence",
    "cloud-ops": "cloud-intelligence",
    ops: "cloud-intelligence",
    sre: "cloud-intelligence",
    "commerce-frontend": "commerce-frontend",
    "commerce-administrators": "commerce-frontend",
    "commerce-implement": "commerce-implement",
    "commerce-routemasters": "commerce-routemasters",
    "commerce-analyze": "commerce-routemasters",
    "commerce-engage-recs-badging-content": "commerce-routemasters",
    "commerce-rbc": "commerce-routemasters",
    "commerce-engage-search-listing": "commerce-routemasters",
    "commerce-sdz": "commerce-routemasters",
    "commerce-shopify": "commerce-shopify",
    comscale: "comscale",
    "connectivity-core": "connectivity-core",
    "coveo-labs-technical-powerhouse": "coveo-labs-technical-powerhouse",
    ctinfra: "ctinfra",
    "connectors-infrastructure": "ctinfra",
    "data-analytics-engineering": "data-analytics-engineering",
    "commerce-paparazzi": "data-analytics-engineering",
    "data-integration": "data-integration",
    "database-data-management": "database-data-management",
    dataplatformfoundation: "dataplatformfoundation",
    usageanalytics: "dataplatformfoundation",
    "data-foundation": "dataplatformfoundation",
    "dev-docs": "dev-docs",
    "dev-writers": "dev-docs",
    "api-writers": "dev-docs",
    "dev-tooling": "dev-tooling",
    cicd: "dev-tooling",
    devtooling: "dev-tooling",
    documentation: "documentation",
    dxui: "dxui",
    dx: "dxui",
    "search-ui": "dxui",
    searchui: "dxui",
    "frontend-foundation": "frontend-foundation",
    "admin-ui": "frontend-foundation",
    "admin-ui-core": "frontend-foundation",
    "ui-tooling": "frontend-foundation",
    "admin-specialists": "frontend-foundation",
    "generic-connectivity": "generic-connectivity",
    websites: "generic-connectivity",
    grc: "grc",
    "index-indexing": "index-indexing",
    index: "index-indexing",
    "index-core": "index-indexing",
    "indexing-pipeline": "index-indexing",
    "index-infrastructure": "index-infrastructure",
    "index-querying": "index-querying",
    "index-core-search": "index-querying",
    "knowledge-core": "knowledge-core",
    "service-core": "knowledge-core",
    "knowledge-data": "knowledge-data",
    ctsvc: "knowledge-data",
    "service-data": "knowledge-data",
    "knowledge-hub": "knowledge-hub",
    "knowledge-hub-experience": "knowledge-hub",
    "service-hub": "knowledge-hub",
    "knowledge-integrations": "knowledge-integrations",
    "salesforce-integration": "knowledge-integrations",
    "service-integrations": "knowledge-integrations",
    "llm-ops": "llm-ops",
    "marketing-website": "marketing-website",
    "ml-commerce-ai": "ml-commerce-ai",
    "ml-profit": "ml-commerce-ai",
    "ml-payg": "ml-commerce-ai",
    "ml-core-ai-dev": "ml-core-ai-dev",
    "ml-search-relevance": "ml-core-ai-dev",
    "ml-recommendations": "ml-core-ai-dev",
    "ml-query-suggest-and-understanding": "ml-core-ai-dev",
    "ml-core-nlp": "ml-core-nlp",
    "ml-experimentation-and-validation": "ml-experimentation-and-validation",
    "ml-infra": "ml-infra",
    "ml-knowai": "ml-knowai",
    "ml-service-ai": "ml-knowai",
    "ml-case-assist": "ml-knowai",
    "ml-smartsnippets": "ml-knowai",
    "ml-operations": "ml-operations",
    "ml-platform-building": "ml-platform-building",
    "ml-experience": "ml-platform-building",
    "ml-platform-building-backend": "ml-platform-building",
    "ml-platform-serving": "ml-platform-serving",
    "ml-services": "ml-platform-serving",
    "native-connectivity": "native-connectivity",
    "service-connectivity": "native-connectivity",
    wpc: "native-connectivity",
    offsec: "offsec",
    "platform-identity-and-entitlements": "platform-identity-and-entitlements",
    organization: "platform-identity-and-entitlements",
    "platform-resource-insight": "platform-resource-insight",
    source: "platform-resource-insight",
    sources: "platform-resource-insight",
    "platform-solution-experience": "platform-solution-experience",
    "product-intelligence": "product-intelligence",
    "real-time-platform": "real-time-platform",
    "commerce-core": "real-time-platform",
    searchapi: "searchapi",
    "search-api": "searchapi",
    "security-cache": "security-cache",
    security: "security",
    "rd-defense": "security",
    "security-defense-systems-blue": "security",
    csec: "security",
    soc: "soc",
    "transformation-and-enablement": "transformation-and-enablement",
    "cloud-advisor": "transformation-and-enablement",
    cloudadvisors: "transformation-and-enablement"
};

//# sourceMappingURL=TeamAliasMappings.js.map